<app-page-header icon="people" title="Usuarios" subtitle="Listado de usuarios del sistema"></app-page-header>

<div class="seguridad-area seguridad-animate-in">
  <div class="container">
    <div class="barra-superior">
      <button type="button" class="btn-pill btn-pill--outline" routerLink="/usuario-alta">
        <span class="material-icons">person_add</span>
        Agregar Nuevo
      </button>
    </div>

    <!-- Buscador -->
    <div class="busqueda">
      <div class="buscador">
        <span class="material-icons">search</span>
        <input
          type="text"
          [(ngModel)]="searchTerm"
          (keyup.enter)="searchUsuarios()"
          placeholder="Nombre, apellido, email o DNI"
          autocomplete="off"
        />
      </div>

      <div class="busqueda__acciones">
        <button
          type="button"
          class="btn-pill btn-pill--primary"
          (click)="searchUsuarios()"
          [disabled]="flagBuscando"
        >
          <span class="material-icons" [class.girando]="flagBuscando">
            {{ flagBuscando ? "autorenew" : "search" }}
          </span>
          {{ flagBuscando ? "Buscando…" : "Buscar" }}
        </button>

        <button
          type="button"
          class="btn-pill btn-pill--outline"
          (click)="clearSearch()"
          [disabled]="!searchPerformed && !(searchTerm || '').trim().length"
        >
          Limpiar
        </button>
      </div>
    </div>

    <p class="ayuda" *ngIf="!searchPerformed">
      Presione <strong>Buscar</strong> para listar todos, o ingrese al menos
      <strong>2 caracteres</strong> para filtrar.
    </p>

    <!-- Filtro local sólo cuando hay resultados cargados -->
    <div class="busqueda" *ngIf="searchPerformed">
      <div class="buscador buscador--wide">
        <span class="material-icons">filter_alt</span>
        <input
          type="text"
          (keyup)="applyFilter($event)"
          placeholder="Filtrar en resultados: nombre, apellido, email o DNI..."
          autocomplete="off"
        />
      </div>
    </div>

    <!-- Tabla -->
    <div class="mat-elevation-z8 tabla-wrapper" *ngIf="searchPerformed">
      <!-- Skeleton de carga -->
      <div class="sk-tabla" *ngIf="!flagLoaded">
        <div class="sk-fila sk-fila--head">
          <span class="sk-bar" *ngFor="let c of displayedColumns"></span>
        </div>
        <div class="sk-fila" *ngFor="let r of skeletonRows">
          <span class="sk-bar" *ngFor="let c of displayedColumns"></span>
        </div>
      </div>

      <!-- Tabla Real -->
      <ng-container *ngIf="flagLoaded">
        <table mat-table [dataSource]="dataSource" matSort>
          <!-- datos de contacto -->
          <ng-container matColumnDef="nombre">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Datos de contacto </th>
            <td mat-cell *matCellDef="let element">
              <div class="contacto">
                <span class="contacto__principal">
                  {{ element.nombrePersona || "SIN DATOS PERSONALES" }}
                  {{ element.apellidoPersona }}
                </span>
                <span class="contacto__sec">{{ element.email }}</span>
              </div>
            </td>
          </ng-container>

          <!-- identificacion -->
          <ng-container matColumnDef="identificacion">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Identificación </th>
            <td mat-cell *matCellDef="let element">
              <span class="mono">{{ element.identificacion || "S/D" }}</span>
            </td>
          </ng-container>

          <!-- perfil -->
          <ng-container matColumnDef="perfil">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Perfil </th>
            <td mat-cell *matCellDef="let element">
              {{ element.perfil?.descripcion || element.perfil }}
            </td>
          </ng-container>

          <!-- estado -->
          <ng-container matColumnDef="estado">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Estado </th>
            <td mat-cell *matCellDef="let element">
              <span class="chip" [ngClass]="element.suspendido ? 'chip--error' : 'chip--ok'">
                {{ element.suspendido ? "Suspendido" : "Activo" }}
              </span>
            </td>
          </ng-container>

          <!-- aceptaTerminos -->
          <ng-container matColumnDef="aceptaTerminos">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Términos </th>
            <td mat-cell *matCellDef="let element">
              <span class="material-icons estado-ico"
                [ngClass]="element.aceptaTerminos ? 'estado-ico--si' : 'estado-ico--no'">
                {{ element.aceptaTerminos ? "check_circle" : "remove_circle_outline" }}
              </span>
            </td>
          </ng-container>

          <!-- email_verified -->
          <ng-container matColumnDef="email_verified">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Email verificado </th>
            <td mat-cell *matCellDef="let element">
              <span class="material-icons estado-ico"
                [ngClass]="element.email_verified ? 'estado-ico--si' : 'estado-ico--no'">
                {{ element.email_verified ? "check_circle" : "remove_circle_outline" }}
              </span>
            </td>
          </ng-container>

          <!-- pin -->
          <ng-container matColumnDef="pin">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> PIN </th>
            <td mat-cell *matCellDef="let element">
              <span class="mono">{{ element.pin || "-" }}</span>
            </td>
          </ng-container>

          <!-- created -->
          <ng-container matColumnDef="created">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Creado </th>
            <td mat-cell *matCellDef="let element">
              {{ element.createdAt | date : "dd/MM/yyyy" }}
            </td>
          </ng-container>

          <!-- acciones -->
          <ng-container matColumnDef="_id">
            <th mat-header-cell *matHeaderCellDef> Acciones </th>
            <td mat-cell *matCellDef="let element">
              <div class="acciones-row">
                <button
                  type="button"
                  class="accion-ico accion-ico--edit"
                  title="Modificar datos usuario"
                  aria-label="Modificar datos usuario"
                  (click)="verUsuario(element._id)"
                >
                  <span class="material-icons">edit_note</span>
                </button>
                <button
                  type="button"
                  class="accion-ico accion-ico--key"
                  title="Modificar contraseña"
                  aria-label="Modificar contraseña"
                  (click)="openDialogModificarClave(element._id)"
                >
                  <span class="material-icons">key</span>
                </button>
              </div>
            </td>
          </ng-container>

          <!-- sin coincidencias -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length">
              Sin coincidencias para "<strong>{{ (searchTerm || "").trim() }}</strong
              >".
            </td>
          </tr>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            class="example-element-row"
          ></tr>
        </table>

        <mat-paginator
          *ngIf="dataSource?.data?.length"
          [pageSizeOptions]="[50, 100, 150, 200, 500, 800]"
          aria-label="Select page of users"
        ></mat-paginator>
      </ng-container>
    </div>
  </div>
</div>
